import React from 'react';
import {
  Building2,
  Gavel,
  Banknote,
  Ruler,
  Globe,
  Scale,
  LineChart,
  ArrowRight,
  ThumbsUp,
  Users,
  ShieldCheck,
} from 'lucide-react';

const Services = () => {
  return (
    <section className="our-service-container-fb">
      {/* Header */}
      <div className="our-service-header-fb">
        <h1 className="our-service-title-fb">Comprehensive Real Estate Services</h1>
        <p className="our-service-subtitle-fb">
          Premium solutions tailored to elevate your property journey
        </p>
      </div>

      {/* Services Grid */}
      <div className="our-service-grid-fb">
        <div className="our-service-card-fb">
          <Gavel className="our-service-icon-fb" />
          <h2 className="our-service-card-title-fb">Property Legal Assistance</h2>
          <p className="our-service-card-desc-fb">
            Navigate documentation, verification, and compliance with expert legal support.
          </p>
        </div>
        <div className="our-service-card-fb">
          <Banknote className="our-service-icon-fb" />
          <h2 className="our-service-card-title-fb">Home Loan Support</h2>
          <p className="our-service-card-desc-fb">
            Find the right home financing options through our trusted lending partners.
          </p>
        </div>
        <div className="our-service-card-fb">
          <Ruler className="our-service-icon-fb" />
          <h2 className="our-service-card-title-fb">Interior Solutions</h2>
          <p className="our-service-card-desc-fb">
            Harmonize your space with customized design and traditional insights.
          </p>
        </div>
        <div className="our-service-card-fb">
          <Globe className="our-service-icon-fb" />
          <h2 className="our-service-card-title-fb">NRI Real Estate Services</h2>
          <p className="our-service-card-desc-fb">
            Streamlined property solutions for buying, selling, and managing from abroad.
          </p>
        </div>
        <div className="our-service-card-fb">
          <LineChart className="our-service-icon-fb" />
          <h2 className="our-service-card-title-fb">Real Estate Consulting</h2>
          <p className="our-service-card-desc-fb">
            Strategic insights to help you invest, scale, or exit with confidence.
          </p>
        </div>
        {/* ✅ New Registered Transactions */}
        <div className="our-service-card-fb">
          <Building2 className="our-service-icon-fb" />
          <h2 className="our-service-card-title-fb">Registered Transactions</h2>
          <p className="our-service-card-desc-fb">
            Ensure legally compliant and secure property transfers with complete registration support.
          </p>
        </div>
      </div>

      {/* Benefits Header */}
      <div className="our-service-header-fb">
        <h1 className="our-service-title-fb">Why Choose Big House?</h1>
        <p className="our-service-subtitle-fb">
          Discover the difference of working with a trusted real estate partner
        </p>
      </div>

      {/* Benefits Section */}
      <div className="our-service-benefits-grid-fb">
        <div className="our-service-benefit-card-fb">
          <ThumbsUp className="our-service-benefit-icon-fb" />
          <h3>Trusted Expertise</h3>
          <p>
            Over 20 years of market experience and a portfolio built on results.
          </p>
        </div>
        <div className="our-service-benefit-card-fb">
          <Users className="our-service-benefit-icon-fb" />
          <h3>Local Market Knowledge</h3>
          <p>
            In-depth understanding of neighborhoods, trends, and buyer behavior.
          </p>
        </div>
        <div className="our-service-benefit-card-fb">
          <ShieldCheck className="our-service-benefit-icon-fb" />
          <h3>Transparent Process</h3>
          <p>
            Honest guidance, clear timelines, and no hidden surprises.
          </p>
        </div>
        <div className="our-service-benefit-card-fb">
          <ShieldCheck className="our-service-benefit-icon-fb" />
          <h3>Post Sales Assistance</h3>
          <p>
            From documentation to support, we assist you even after the purchase.
          </p>
        </div>
        <div className="our-service-benefit-card-fb">
          <ShieldCheck className="our-service-benefit-icon-fb" />
          <h3>Verified Property Data Base</h3>
          <p>
            Get Verified Property Data Base for your dream home.
          </p>
        </div>
      </div>

      {/* Call to Action */}
      <div className="our-service-cta-fb">
        <p className="our-service-benefit-fb">
          Experience real estate redefined — where trust meets excellence.
        </p>
        <a href="/contact-us" className="our-service-button-fb">
          Learn More About Our Services <ArrowRight size={18} />
        </a>
      </div>
    </section>
  );
};

export default Services;
